import { driverTypes, stateTypes } from '@/utils/dictionary/freight';

import {
  oilApplyCount,
  oilUseRecordListCount,
  oilUseRecordListExport,
  oilUseRecordList,
  getOilType,
} from '@/api/freight';

const storeModuleName = 'payRecordModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'select',
      param: 'state',
      value: '',
      valueType: 'string',
      state: 'stateTypes',
      label: '交易类型',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
      multiple: false,
    },
    {
      style: 'date-picker',
      param: 'applyTime',
      value: [],
      valueType: 'date',
      label: '交易时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['payTimeStart', 'payTimeEnd'],
    },
    {
      style: 'input',
      value: '',
      label: '交易编号',
      placeholder: '请输入',
      clearable: true,
      param: 'orderSn',
    },
    {
      style: 'select',
      param: 'driverProperty',
      value: '',
      valueType: 'string',
      state: 'driverTypes',
      label: '司机类型',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
      multiple: false,
    },
    {
      style: 'input',
      value: '',
      label: '油站名称',
      placeholder: '请输入',
      clearable: true,
      param: 'stationName',
    },
    {
      style: 'select',
      param: 'fuelCodeName',
      state: 'oilList',
      value: '',
      valueType: 'string',
      label: '油品名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: true,
      path: `${storeModuleName}/getOilTypeList`,
    },
  ],
  // 导出
  isExport: {
    isShow: true,
    method: 'get',
    url: oilUseRecordListExport,
  },
  // 页码 + 参数
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '交易编号',
        prop: 'orderSn',
        width: 130,
        checked: 1,
        sortable: true,
        // slotName: 'sub-domain-message',
      },
      {
        label: '交易时间',
        width: 160,
        prop: 'payTime',
        checked: 1,
        sortable: true,
        // slotName: 'sub-domain-waybill',
      },
      {
        label: '司机信息',
        width: 150,
        prop: 'driverName',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-driverName',
      },
      {
        label: '加油数据',
        prop: 'quantity',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-quantity',
      },
      {
        label: '商品信息',
        prop: 'stationName',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-stationName',
      },
      {
        label: '交易类型',
        width: 100,
        prop: 'state',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-state',
      },
    ],
  },
  companyList: [],
  routeList: [],
  report: {},
  oilList: [],
  driverTypes, // 司机类型
  stateTypes, // 交易状态
};
// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });

    // 获取统计信息
    const { data } = await oilUseRecordList(Object.assign({}, params, context.state.postParams));
    data.list = data.records;
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, { list: data.records, total: data.total }),
    });

    oilUseRecordListCount(Object.assign({}, params)).then(res => {
      context.commit('updateReport', Object.assign({}, res.data));
    });
  },
  // 获取企业列表
  getCompanyList: (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 油站名称
  getOilTypeList: async (context, keyword) => {
    const { code, data } = await getOilType();
    let newdata = [];
    if (code === 200) {
      newdata = data.map(item => {
        return {
          label: item,
          value: item,
        };
      });
      context.commit('updateState', {
        key: 'oilList',
        value: newdata,
      });
    }
  },
};

const mutations = {
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },

  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新统计信息
  updateReport(state, payload) {
    state.report = payload;
  },
  // 重置所有状态
  initFilter(state) {
    state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
